/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";

import { Field } from "formik";
import { makeStyles } from "@material-ui/core/styles";

type TProps = {
  question: {
    options: {
      id: number;
      text: string;
      type: string;
    }[];
    id: number;
    text: string;
    mandatory: boolean;
  };
  errorMsg: string | null;
  submitCount: number;
};

const useClasses = makeStyles(() => ({
  placeholder: {
    "&::placeholder": {
      color: "#717171",
    },
  },
}));

function SurveyTextInput({ question, errorMsg, submitCount }: TProps) {
  const option = question.options[0];
  const classes = useClasses();

  return (
    <>
      <Field
        aria-describedby={errorMsg ? `error-${question.id}` : undefined}
        aria-invalid={!!errorMsg}
        aria-label={`${question.text} ${question.mandatory ? "*" : ""}`}
        aria-required={question.mandatory}
        className={`form-control input-sm utils-fs-12px-imp ${classes.placeholder}`}
        name={question.id}
        placeholder={option.text}
      />
      {errorMsg && (
        <span
          id={`error-${question.id}`}
          key={`error-${question.id}-${submitCount}`}
          className="sr-only"
          role="alert"
        >
          {I18n.t("surveys.error", { question: question.text })}
        </span>
      )}
    </>
  );
}

export default SurveyTextInput;
